/**
 * 读取设备安全区域（刘海屏 / 底部指示条）的 inset 值
 * 通过创建临时元素测量 env(safe-area-inset-*) 的实际像素值
 */

let _cachedBottom = -1;

/** 获取底部安全区域高度（px），结果缓存 */
export function getSafeAreaBottom(): number {
  if (_cachedBottom >= 0) return _cachedBottom;

  if (typeof document === "undefined") {
    _cachedBottom = 0;
    return 0;
  }

  try {
    const el = document.createElement("div");
    el.style.cssText =
      "position:fixed;bottom:0;padding-bottom:env(safe-area-inset-bottom,0px);pointer-events:none;visibility:hidden;";
    document.body.appendChild(el);
    const pb = parseFloat(getComputedStyle(el).paddingBottom) || 0;
    document.body.removeChild(el);
    _cachedBottom = pb;
    return pb;
  } catch {
    _cachedBottom = 0;
    return 0;
  }
}
